import type { EntryPointComponent } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { RouteResources } from '@atlassian/react-resource-router';
import { MenuIdFilters } from '@jira/navigation-apps__constants/src/MenuIdFilters.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { LegacyEntryRoute } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { RootLifecycleEntryPointContainer } from '@jira/platform__spa/src/view/RootLifecycleEntryPointContainer.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalIssueNavigatorRoute } from '@jira/router-routes__legacy-global-issue-navigator-routes/src/globalIssueNavigatorRoute.tsx';
import { LegacyPageWithTeamProfileCardView } from './ui/legacy-team-profile-card-view/index.tsx';

const globalIssueNavigatorMigrationEmptyProps = {};
const globalIssueNavigatorMigrationEntryPoint0 = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-globalIssueNavigator-0" */ './GlobalIssueNavigatorRoot.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => globalIssueNavigatorMigrationEmptyProps,
	},
});

export const globalIssueNavigatorRouteEntry: LegacyEntryRoute<RouteResources> = createLegacyEntry(
	globalIssueNavigatorRoute,
	() => ({
		apdexIgnoreParams: ['issueKey'],
		canTransitionIn: () => false,

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_9')
			? undefined
			: LegacyPageWithTeamProfileCardView,

		layout: globalLayout,

		navigation: {
			menuId: MenuIdFilters,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_9')
				? globalIssueNavigatorMigrationEntryPoint0
				: undefined,
		entryPointContainer: fg('nike_entrypoint_migration_batch_9')
			? RootLifecycleEntryPointContainer
			: undefined,
	}),
);
